const CONTACTS_KEY = 'zeitamax_contacts';
const JOBS_KEY = 'zeitamax_jobs';
const GOOGLE_SHEETS_WEB_APP_URL = process.env.REACT_APP_GOOGLE_SHEETS_WEB_APP_URL
  || 'https://script.google.com/macros/s/AKfycbzWciorm-6mQQpKc2eWK4PGa4MM2mbByjYXy85XPuzEgCF9Zu855yAmUWw4cAsdpWilpw/exec';
export const DATA_UPDATED_EVENT = 'zeitamax-data-updated';

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]');
  } catch {
    return [];
  }
}

function write(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(DATA_UPDATED_EVENT));
}

export const getContacts = () => read(CONTACTS_KEY);
export const getJobs = () => read(JOBS_KEY);

export function saveContact(contact) {
  write(CONTACTS_KEY, [{ ...contact, id: Date.now(), submittedAt: new Date().toISOString() }, ...getContacts()]);
}

export async function saveContactToGoogleSheet(contact) {
  const endpoint = GOOGLE_SHEETS_WEB_APP_URL;
  if (!endpoint || endpoint.includes('YOUR_DEPLOYMENT_ID')) {
    throw new Error('Google Sheets web app URL is not configured.');
  }

  await fetch(endpoint, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify(contact),
  });

}

export async function saveApplicationToGoogleSheet(application) {
  const endpoint = GOOGLE_SHEETS_WEB_APP_URL;
  if (!endpoint || endpoint.includes('YOUR_DEPLOYMENT_ID')) {
    throw new Error('Google Sheets web app URL is not configured.');
  }

  await fetch(endpoint, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({ type: 'jobApplication', ...application }),
  });
}

export function saveJob(job) {
  const newJob = { ...job, id: Date.now(), postedAt: new Date().toISOString() };
  write(JOBS_KEY, [newJob, ...getJobs()]);
  return newJob;
}

export function removeJob(id) {
  write(JOBS_KEY, getJobs().filter((job) => job.id !== id));
}
